module.exports = __webpack_public_path__ + "assets/img/gal_04.37ccd570.jpg";